<template>
    <div class="panorama">
        <sep name="L" />
        <panorama-inner
            v-if="insurers && annotationOptions && apenafsByCode && subjects"
            :annotationOptions="annotationOptions"
            :insurers="insurers"
            :apenafsByCode="apenafsByCode"
            :subjects="subjects"
        />
    </div>
</template>

<script>
import PanoramaInner from "./PanoramaInner.vue";
import { Services } from "src/services/Services";
import userMixin from "src/mixins/user";
import { isTodayAfter2025 } from "src/helpers/naf.helper";

export default {
    components: {
        PanoramaInner,
    },
    mixins: [userMixin],
    props: ["user"],
    created() {
        if (!this.isSubscribedToPanorama) this.$router.push({ name: "cc" });
    },
    asyncComputed: {
        async insurers() {
            return await Services.api.insurer.getAllInsurers();
        },
        async annotationOptions() {
            return await Services.api.annotationOption.getAll();
        },
        async subjects() {
            const subjectsResponse = await Services.api.subject.getAll();
            return Object.keys(subjectsResponse)
                .map(key => {
                    if (subjectsResponse[key]["type"]) {
                        return subjectsResponse[key];
                    } else {
                        return null;
                    }
                })
                .filter(s => s !== null);
        },
        async apenafsByCode() {
            return isTodayAfter2025()
                ? await Services.api.ca.getApenafs2025()
                : await Services.api.ca.getApenafs2008();
        },
    },
};
</script>

<style scoped lang="sass"></style>
